/**
 * @param url
 * @returns {*|Array|{index: number, input: string}}
 */
function getBaseVersion(url) {
  const semverMatches = url.match(/\/(\d+\.\d+\.\d+)\/?$/)
  return semverMatches && semverMatches[1]
}

export {
  getBaseVersion
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/lib/common/getBaseVersion.js